import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import * as fromContext from 'src/app/core/state/context';
import * as fromRoot from '../../core/state/core.state';

@Injectable({
  providedIn: 'root'
})
export class DistributorService {
  constructor(protected store: Store<fromRoot.State>) {}

  public GetDistributorCode(): string {
    let contextDistributorCode: string | null | undefined;
    this.store
      .select(fromContext.selectContext)
      .pipe(take(1))
      .subscribe(ctx => (contextDistributorCode = ctx.contextData?.codeVendeur));
    return contextDistributorCode ?? '';
  }
}
